module.exports = require("./sl-SI.js");